import { IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import Eventi from '../components/Eventi';
import UtenteButton from '../components/UtenteButton';

const EventiTab: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Eventi</IonTitle>
          <IonButtons slot="end">
            <UtenteButton triggerId={'trigger-button'+'_eventi'}/>            
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Eventi</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Eventi />
      </IonContent>
    </IonPage>
  );
};

export default EventiTab;
